import React, { useEffect, useMemo, useRef, useState } from 'react';

const ADSENSE_STATUS = {
  LOADING: 'loading',
  READY: 'ready',
  BLOCKED: 'blocked',
};

function isDev() {
  return process.env.NODE_ENV !== 'production';
}

function resolveClientId() {
  return String(process.env.REACT_APP_ADSENSE_CLIENT_ID || '').trim();
}

export default function GoogleAdSense({ variant = 'card', seed = 0, category = 'all' }) {
  const clientId = resolveClientId();
  const adRef = useRef(null);
  const [status, setStatus] = useState(ADSENSE_STATUS.LOADING);

  const slotKey = useMemo(
    () => `mingo-${variant}-${category}-${seed}`,
    [variant, category, seed],
  );

  useEffect(() => {
    if (!clientId) {
      setStatus(ADSENSE_STATUS.BLOCKED);
      return;
    }
    if (isDev()) {
      setStatus(ADSENSE_STATUS.READY);
      return;
    }
    const win = window;
    if (!win.adsbygoogle || !adRef.current) {
      setStatus(ADSENSE_STATUS.BLOCKED);
      return;
    }
    try {
      win.adsbygoogle.push({});
    } catch {
      setStatus(ADSENSE_STATUS.BLOCKED);
      return;
    }

    const checkTimer = window.setTimeout(() => {
      const hasFrame = !!adRef.current?.querySelector('iframe');
      setStatus(hasFrame ? ADSENSE_STATUS.READY : ADSENSE_STATUS.BLOCKED);
    }, 1500);

    return () => window.clearTimeout(checkTimer);
  }, [clientId, slotKey]);

  if (!clientId) return null;

  if (isDev()) {
    return (
      <div className={`mingo-ad-slot mingo-ad-slot--${variant}`} style={{ opacity: 0.85 }}>
        [DEV] Google AdSense placeholder
      </div>
    );
  }

  if (status === ADSENSE_STATUS.BLOCKED) return null;

  return (
    <ins
      key={slotKey}
      ref={adRef}
      className={`adsbygoogle mingo-ad-slot mingo-ad-slot--${variant}`}
      style={{ display: 'block' }}
      data-ad-client={clientId}
      data-ad-slot={process.env.REACT_APP_ADSENSE_SLOT_ID || '0000000000'}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
